// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_40vlZJG","container":"uVISX5m","paymentOption":"_1dJsPRL","logo":"XFU8Dea"};


//////////////////
// WEBPACK FOOTER
// ./template/components/WelcomeMat/PaymentOptions.css
// module id = ./template/components/WelcomeMat/PaymentOptions.css
// module chunks = client.sitechrome